<template>
  <div>
    <VuePhoneNumberInput
      v-model="computedInputVal"
      default-country-code="US"
      :preferred-countries="['US']"
      required
      @update="onUpdate"
      :class="{ 'input-error': errorMessage }"
    />
    <span class="err-message" v-if="errorMessage">{{ errorMessage }}</span>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";

export default {
  components: { VuePhoneNumberInput },
  props: {
    value: { type: [String, Number], default: null },
    originalValue: { type: [String, Number], default: null } // Add this prop
  },
  data() {
    return {
      errorMessage: "",
      lastCheckedValue: null // Track last checked value
    };
  },
  computed: {
    computedInputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  methods: {
    ...mapActions("auth", {
      checkPhone: "onCheckPhone"
    }),
    onUpdate(payload) {
      this.$emit("update", payload);
      if (!payload.isValid) {
        this.errorMessage = "Invalid phone number";
      } else if (
        payload.nationalNumber.length !== 10 ||
        payload.nationalNumber.length > 10
      ) {
        this.errorMessage = "Phone number must be exactly 10 digits";
      } else {
        // Only check phone if creating or editing with a changed value
        if (
          this.originalValue == null || // creating new
          (payload.nationalNumber !== this.originalValue &&
            payload.nationalNumber !== this.lastCheckedValue) // editing and changed
        ) {
          let params = {
            phone: payload.nationalNumber
          };
          this.checkPhone(params)
            .then(() => {
              this.lastCheckedValue = payload.nationalNumber;
              this.errorMessage = "";
            })
            .catch(error => {
              this.lastCheckedValue = null;
              if (error.response == undefined) {
                console.log(error);
              } else {
                this.errorMessage = error.response.data.message;
              }
            });
        } else {
          // Editing and value not changed, so no error
          this.errorMessage = "";
        }
      }
    }
  }
};
</script>

<style scoped>
.vue-phone-number-input :deep(.country-selector__label) {
  display: none;
}
.vue-phone-number-input :deep(.input-tel__label) {
  display: none;
}

div :deep(.input-tel.has-hint .input-tel__input) {
  padding-top: 0;
}
div :deep(.input-tel.has-value .input-tel__input) {
  padding-top: 0;
}

div :deep(.country-selector.has-value .country-selector__input) {
  padding-top: 0;
}
div :deep(.country-selector__country-flag) {
  top: 14px;
}
.err-message {
  color: red;
  font-size: 12px;
}

.input-error .input-tel__input {
  border-color: red !important;
}
</style>
